function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLivemapSearchresultItemTool = function SvgLivemapSearchresultItemTool(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h22v22H0z",
    "data-name": "Rectangle 4468",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3 15.936-1.1-1.1 1.7-1.65-.929-.93-1.687 1.687L0 12.958l1.513-2.623a2.169 2.169 0 0 1 1.9-1.107h.108l.864.041L6.054 7.6l3.178-3.114-.041-.966a2.233 2.233 0 0 1 1.044-1.947L12.776 0l1.105 1.1-1.706 1.649.929.909 1.686-1.685.984.984-1.513 2.623a2.17 2.17 0 0 1-1.9 1.106h-.109l-.863-.041-1.528 1.526c-.795.794-1.651 1.65-3.321 3.3l.042.945a2.235 2.235 0 0 1-1.044 1.947L3 15.935zm-.389-4.5 1.771 1.772-1.688 1.684.419.376 2.168-1.35a1.661 1.661 0 0 0 .764-1.424l-.021-1.227 5.183-5.223 1.126.059h.1a1.642 1.642 0 0 0 1.383-.803l1.268-2.208-.255-.256-1.684 1.685-1.771-1.772 1.686-1.686-.419-.375-2.189 1.33a1.661 1.661 0 0 0-.762 1.423l.039 1.228-5.182 5.243-1.126-.06h-.1a1.641 1.641 0 0 0-1.382.808L.668 12.865l.255.255 1.685-1.685z",
    "data-name": "Path 11628",
    style: {
      fill: "#4da5b5"
    },
    transform: "translate(3 3)"
  }));
};
export default SvgLivemapSearchresultItemTool;